/**
 * List Item
 * Responsive container for List Items
 */
import React from 'react';

import {
  ItemContainer,
  SubtitleContainer,
  TitleContainer,
} from './ListItemContainer.style';

const ListItemContainer: React.FC<{
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
}> = ({ children = null, title = '', subtitle = '' }) => {
  return (
    <>
      {title ? <TitleContainer>{title}</TitleContainer> : null}
      {subtitle ? <SubtitleContainer>{subtitle}</SubtitleContainer> : null}
      <ItemContainer>{children}</ItemContainer>
    </>
  );
};

export default ListItemContainer;
